<template>

    <!-- Iterate over classes -->
    <tr v-if="classWise" v-for="(clazz, classIndex) in classes" :key="clazz.id">

      <!-- Class Name-->
      <td v-if="classWise">{{ clazz.name }}</td>

      <!-- Iterate over branches -->
      <td v-if="branchWise" v-for="branch in branches">

        <!-- Section wise count for the class and branch -->
        <div v-if="sectionWise" v-for="section in distinctValues({branch_id: branch.id, class_id: clazz.id}, 'section')">
          <SectionWiseCount
            :session="session"
              :student-counts="studentCounts"
              :filter="{branch_id: branch.id, class_id: clazz.id}"
              :section="section"
              :section-wise="sectionWise"
              :type="type"
          />
        </div>
        <div v-else>
          <SectionWiseCount
            :session="session"
              :student-counts="studentCounts"
              :filter="{branch_id: branch.id, class_id: clazz.id}"
              :section="null"
              :is-total="false"
              :section-wise="sectionWise"
              :type="type"
          />
        </div>

        <!-- Total for the class, branch -->
        <div v-if="sectionWise && studentsFilteredBy({branch_id: branch.id, class_id: clazz.id}).sum('student_count')">
          <SectionWiseCount
            :session="session"
              :student-counts="studentCounts"
              :filter="{branch_id: branch.id, class_id: clazz.id}"
              :section="null"
              :is-total="true"
              :section-wise="sectionWise"
              :type="type"
          />
        </div>
      </td>
      <td v-else-if="sectionWise || type !== 'total'">
        <div v-if="sectionWise" v-for="section in distinctValues({class_id: clazz.id}, 'section')">
          <SectionWiseCount
            :session="session"
              :student-counts="studentCounts"
              :filter="{class_id: clazz.id}"
              :section="section"
              :section-wise="sectionWise"
              :type="type"
          />
        </div>
        <div v-else>
          <SectionWiseCount
            :session="session"
              :student-counts="studentCounts"
              :filter="{class_id: clazz.id}"
              :section="null"
              :is-total="false"
              :section-wise="sectionWise"
              :type="type"
          />
        </div>

        <!-- Total for the class -->
        <div v-if="sectionWise && studentsFilteredBy({class_id: clazz.id}).sum('student_count')">
          <SectionWiseCount
            :session="session"
              :student-counts="studentCounts"
              :filter="{class_id: clazz.id}"
              :section="null"
              :is-total="true"
              :section-wise="sectionWise"
              :type="type"
          />
        </div>
      </td>

      <!-- Total column for the class -->
      <td v-if="branchWise">
        <a :href="studentsDetailUrl({class: clazz.id})">
          {{studentsFilteredBy({class_id: clazz.id}).sum('student_count') }}
        </a>
      </td>
    </tr>
    <!-- Iterate over classes ends -->

   <!-- Not Class Wise -->
    <tr v-else>
      <!-- Iterate over branches -->
      <td v-if="branchWise" v-for="branch in branches">

        <!-- Section wise count for the class and branch -->
        <div v-if="sectionWise" v-for="section in distinctValues({branch_id: branch.id}, 'section')">
          <SectionWiseCount
            :session="session"
              :student-counts="studentCounts"
              :filter="{branch_id: branch.id}"
              :section="section"
              :section-wise="sectionWise"
              :type="type"
          />
        </div>
        <div v-else>
          <SectionWiseCount
            :session="session"
              :student-counts="studentCounts"
              :filter="{branch_id: branch.id}"
              :section="null"
              :is-total="false"
              :section-wise="sectionWise"
              :type="type"
          />
        </div>

        <!-- Total for the class, branch -->
        <div v-if="sectionWise && studentsFilteredBy({branch_id: branch.id}).sum('student_count')">
          <SectionWiseCount
            :session="session"
              :student-counts="studentCounts"
              :filter="{branch_id: branch.id}"
              :section="null"
              :is-total="true"
              :section-wise="sectionWise"
              :type="type"
          />
        </div>
      </td>
      <td v-else-if="sectionWise || type !== 'total'">
        <div v-if="sectionWise" v-for="section in distinctValues({}, 'section')">
          <SectionWiseCount
            :session="session"
              :student-counts="studentCounts"
              :filter="{}"
              :section="section"
              :section-wise="sectionWise"
              :type="type"
          />
        </div>
        <div v-else>
          <SectionWiseCount
            :session="session"
              :student-counts="studentCounts"
              :filter="{}"
              :section="null"
              :is-total="false"
              :section-wise="sectionWise"
              :type="type"
          />
        </div>

        <!-- Total for the class -->
        <div v-if="sectionWise && studentsFilteredBy({}).sum('student_count')">
          <SectionWiseCount
            :session="session"
              :student-counts="studentCounts"
              :filter="{}"
              :section="null"
              :is-total="true"
              :section-wise="sectionWise"
              :type="type"
          />
        </div>
      </td>

      <!-- Total column for the class -->
      <td v-if="branchWise">
        <a :href="studentsDetailUrl({})">
          {{studentsFilteredBy({}).sum('student_count') }}
        </a>
      </td>
    </tr>

    <!-- Grand Total -->
    <tr
      style="background-color: #f3f3f3" class="font-weight-bold">
      <td v-if="classWise">Grand Total</td>
      <td v-if="branchWise" v-for="branch in branches">
        <SectionWiseCount
            :session="session"
            :student-counts="studentCounts"
            :filter="{branch_id: branch.id}"
            :section="null"
            :is-grand-total="true"
            :section-wise="sectionWise"
            :type="type"
        />
      </td>
      <td v-else>
        <SectionWiseCount
            :session="session"
            :student-counts="studentCounts"
            :filter="{}"
            :section="null"
            :is-total="false"
            :section-wise="sectionWise"
            :type="type"
        />
      </td>
      <td v-if="type === 'total' || branchWise">
        <a :href="studentsDetailUrl({})">
          {{ studentsFilteredBy({}).sum('student_count') }}
        </a>
      </td>
    </tr>
</template>

<script>
import {Collection} from "collect.js";
import SectionWiseCount from "./SectionWiseCount.vue";

export default {
  components: {SectionWiseCount},
  props: {
    type: String,
    session: Number,
    studentCounts: Collection,
    branches: Collection,
    classes: Collection,
    shifts: Collection,
    classWise: Boolean,
    branchWise: Boolean,
    sectionWise: Boolean,
  },
  methods: {
    studentsFilteredBy(filter) {
      if (this.session) {
        filter['session_id'] = this.session;
      }

      return this.studentCounts.filter((count) => {
        return Object.keys(filter).every(key => count[key] === filter[key]);
      });
    },
    distinctValues(filter, valueKey) {
      return this.studentsFilteredBy(filter)
          .map((count) => { return {id: count[valueKey+'_id'], name: count[valueKey]} }).unique('id');
    },
    studentsDetailUrl(filter) {
      if (this.session) {
        filter['session'] = this.session;
      }

      return route('students.index', filter);
    }
  }
}
</script>

<style scoped>
.table th div{
  padding: 0.5rem;
}
</style>